/**
 * @generated SignedSource<<305e5bc39ac22ad92c3e2570bc0b7c1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobPostingStatus = "APPROVED" | "ARCHIVED" | "COMPLETED" | "EXPIRED" | "PAUSED" | "PENDING" | "PENDING_REVISION" | "REJECTED" | "%future added value";
export type PaidProjectStatus = "ARCHIVED" | "AWAITING_PAYMENT" | "CANCELLATION_REQUESTED" | "CANCELLED" | "COMPLETED" | "CONTRACT_SIGNED" | "DISPUTED" | "INQUIRY_ACCEPTED" | "INQUIRY_DECLINED" | "INQUIRY_RECEIVED" | "INQUIRY_SUBMITTED" | "IN_PROGRESS" | "IN_REVIEW" | "PROPOSAL_DECLINED" | "PROPOSAL_RECEIVED" | "PROPOSAL_SUBMITTED" | "REJECTED" | "SUBMISSION_CREATED" | "SUBMISSION_DECLINED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AllProfileWorkOpportunityResultsListView_userAccount$data = {
  readonly id: string;
  readonly jobPostings: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly status: JobPostingStatus;
        readonly visitorApplication: {
          readonly paidProjectV2: {
            readonly status: PaidProjectStatus;
          };
        } | null;
        readonly visitorCanEdit: boolean;
        readonly " $fragmentSpreads": FragmentRefs<"JobPostingCard_jobPosting">;
      };
    }>;
  };
  readonly " $fragmentType": "AllProfileWorkOpportunityResultsListView_userAccount";
};
export type AllProfileWorkOpportunityResultsListView_userAccount$key = {
  readonly " $data"?: AllProfileWorkOpportunityResultsListView_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllProfileWorkOpportunityResultsListView_userAccount">;
};

import AllProfileWorkOpportunityResultsListViewQuery_graphql from './AllProfileWorkOpportunityResultsListViewQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jobPostings"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": AllProfileWorkOpportunityResultsListViewQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "AllProfileWorkOpportunityResultsListView_userAccount",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "jobPostings",
      "args": null,
      "concreteType": "UserProfileJobPostingsConnection",
      "kind": "LinkedField",
      "name": "__AllProfileWorkOpportunityResultsListView_jobPostings_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileJobPostingsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobPosting",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "visitorCanEdit",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobPostingApplication",
                  "kind": "LinkedField",
                  "name": "visitorApplication",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "paidProjectV2",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "JobPostingCard_jobPosting"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "737e8afe6caf5122bbcc4bd6d3aa0145";

export default node;
